module.exports = __webpack_public_path__ + "static/img/banner_journey@2x - 副本.3c6b2ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journey/banner_journey@2x - 副本.png
// module id = O09L
// module chunks = 1